import styles from './Motability7Buttons.module.scss';
import Button from '../../../../../ui/Button/Button';
import React from 'react';

export default function Buttons({ slide }) {
  const handleClick = (buttonPath) => {
    if (buttonPath) {
      window.location.href = buttonPath;
    }
  };

  return (
    <div className={styles.buttons} data-aos="fade-up">
      {slide.buttons?.map((button, index) =>
        button.isComingSoon ? (
          <button key={index} className={styles.comingSoon}>
            Coming soon
          </button>
        ) : (
          <Button
            key={index}
            className={styles.button}
            variant={button?.type || 'primary'}
            isShowTooltip={!button?.path}
            onClick={() => handleClick(button?.path ? button.path : undefined)}
          >
            {button.label}
          </Button>
        )
      )}
    </div>
  );
}
